var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55716 16.2039C3.74456 17.5958 4.89743 18.6863 6.30037 18.7508C7.48088 18.805 8.68007 18.8333 10.0007 18.8333C11.3212 18.8333 12.5204 18.805 13.7009 18.7508C15.1039 18.6863 16.2567 17.5958 16.4442 16.2039C16.5665 15.2956 16.6673 14.3647 16.6673 13.4167C16.6673 12.4687 16.5665 11.5378 16.4442 10.6294C16.2567 9.2375 15.1039 8.14707 13.7009 8.08257C12.5204 8.02831 11.3212 8 10.0007 8C8.68007 8 7.48088 8.02831 6.30037 8.08257C4.89743 8.14707 3.74456 9.2375 3.55716 10.6294C3.43486 11.5378 3.33398 12.4687 3.33398 13.4167C3.33398 14.3647 3.43486 15.2956 3.55716 16.2039Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.99996V5.91663C6.25 3.84556 7.92893 2.16663 10 2.16663C12.0711 2.16663 13.75 3.84556 13.75 5.91663V7.99996",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 13.4083V13.4167",
    stroke: "#8A8A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.4083V13.4167",
    stroke: "#8A8A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 13.4083V13.4167",
    stroke: "#8A8A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.7b9ee6da9223ac255676a01f19bb1e2c.svg";
export { ForwardRef as ReactComponent };